export default __webpack_public_path__ + "static/media/auth-bg.9a62e575.png";